import { InputAdornment, ListItemIcon } from '@mui/material';
import CSelect from './select';
import { ISelectOption } from 'types/molecules';
import { CMenuItem } from 'components/atoms';
import { useState, ChangeEvent } from 'react';
import { useTranslation } from 'react-i18next';
import { useAppDispatch, useAppSelector } from 'hooks/redux';
import { setLanguageId } from 'store/app/app-slice';
import { api } from 'services/api';
import dayjs from 'dayjs';
import 'dayjs/locale/en';
import 'dayjs/locale/tr';
import { setProfile } from 'store/auth/auth-slice';
import { ReactComponent as WorldSvg } from 'assets/svg/world.svg';
import { useChangeLanguageMutation } from 'services/pet-owner';

export default function LanguageSelect({ type = 'select' }: { type?: 'select' | 'click' }) {
  const { i18n } = useTranslation();

  const options: ISelectOption[] = [
    {
      value: 'tr',
      label: 'TR',
      data: {
        id: 1,
      },
    },
    {
      value: 'en',
      label: 'EN',
      data: {
        id: 2,
      },
    },
  ];

  const [sendChangedLanguage] = useChangeLanguageMutation();
  const [isOpen, setIsOpen] = useState(false);
  const [language, setLanguage] = useState(i18n.resolvedLanguage ?? options[0].value);
  const user = useAppSelector((state) => state.auth.user);
  const dispatch = useAppDispatch();

  const handleChange = (
    event: ChangeEvent<HTMLTextAreaElement | HTMLInputElement> | null,
    langShortName?: 'tr' | 'en'
  ) => {
    const value = event?.target?.value ?? (langShortName as string);

    setLanguage(value);
    i18n.changeLanguage(value);
    dispatch(setProfile({ languageId: value === 'tr' ? 1 : 2 }));
    dispatch(setLanguageId(value === 'tr' ? 1 : 2));
    dispatch(api.util.resetApiState());
    dayjs.locale(value);
    document.documentElement.lang = value; // <html lang=''>
    if (user) sendChangedLanguage({});
  };

  return type === 'select' ? (
    <CSelect
      id="language"
      name="language"
      value={language}
      onChange={(event) => {
        handleChange(event);
      }}
      borderless
      onClick={() => setIsOpen(!isOpen)}
      SelectProps={{
        open: isOpen,
        onOpen: () => setIsOpen(true),
        onClose: () => setIsOpen(false),
      }}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start" className="h-full w-5 shrink-0">
            <WorldSvg />
          </InputAdornment>
        ),
        className: 'cursor-pointer',
      }}
    >
      {options.map((option) => (
        <CMenuItem key={option.value} value={option.value}>
          {option.label}
        </CMenuItem>
      ))}
    </CSelect>
  ) : (
    <CMenuItem
      onClick={() =>
        handleChange(null, options.find((option) => option.value !== language)?.value as 'tr' | 'en')
      }
      className="fill-transparent hover:fill-primary-200"
    >
      <ListItemIcon className="text-inherit">
        <WorldSvg className="h-6 w-6 fill-inherit" />
      </ListItemIcon>

      <span>{options.find((option) => option.value !== language)?.label}</span>
    </CMenuItem>
  );
}

